export default {
  header: 'Vaya, algo inesperado ha ocurrido',
  text: 'Reinicia la página o haz clic en el botón «Volver al menú» a continuación.',
  button: 'Volver al menú',
};
